var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--auth auth"},[_c('div',{staticClass:"auth__body"},[_c('router-view',{staticClass:"auth__content",attrs:{"name":"content"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }